import { ErrorPage } from '@backstage/core-components';
import React from 'react';

export const PermissionErrorPage = () => {
  return React.createElement(ErrorPage, { status: "403", statusMessage: "Forbidden",} );
};
